import * as HLF from "html-living-framework";

export class LayoutSprite extends PIXI.Sprite {
    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        if (typeof texture === "string") {
            texture = texture.replace(/\.png$|\.jpe?g$/, "");
            texture = texture.replace(/@2x$|@1x$/, "");
            this.name = texture;
        }
        this.texture = (texture instanceof PIXI.Texture ? texture :
            texture ? HLF.PixiUtils.getTexture(texture) : PIXI.Texture.EMPTY) || PIXI.Texture.EMPTY;
        this.anchor.x = anchorX;
        this.anchor.y = anchorY;

        this.scale.set(Math.min(this.scale.x, this.scale.y)); // preserve aspect ratio
    }

    public onLayout() {
        //
    }
}